// @ts-nocheck
/* eslint-disable */
import Content from './content';

/**
 * @class Vytváří položku obsahu vizitky - platnost dopravní informace
 * @augments Content
 * @private
 */
 export default class Lifetime extends Content {
	_build() {
		this._dom.container.classList.add("content-lifetime");

		var str = "";

		if (this._options.updated) {
			if (this._data.updated) {
				str += this._buildTS(this._data.updated.label, this._data.updated.value);
			}
		} else {
			str += this._buildTS(this._data.from.label, this._data.from.value);
			str += this._buildTS(this._data.to.label, this._data.to.value);
		}

		this._dom.container.innerHTML = str;
	}

	_buildTS(label, ts, strong) {
		return "<p><span>" + label + ":</span> " + (strong ? "<strong>" : "") + ts + (strong ? "</strong>" : "") + "</p>";
	}
}
